import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo, useState } from 'react';
import { calculateScrollDistance, getTotalScrollDistance } from '../utils';
import { useDeviceType } from '../../../../responsive';
/** Хук реализует всю логику над кнопками скролящегося контейнера табов */
export const useCarouselButtons = _ref => {
  let {
    scrollableContainerRef,
    tabsRef
  } = _ref;
  const deviceType = useDeviceType();
  const [buttonsVisibilityState, setButtonsVisibilityState] = useState({
    showLeftCarouselButton: false,
    showRightCarouselButton: false
  });
  useEffect(() => {
    const scrollableContainer = scrollableContainerRef.current;
    if (!scrollableContainer) {
      return () => {};
    }
    const calculateButtonsVisibility = () => {
      setButtonsVisibilityState({
        showLeftCarouselButton: scrollableContainer.scrollLeft > 0,
        showRightCarouselButton: scrollableContainer.scrollWidth > Math.round(scrollableContainer.clientWidth + scrollableContainer.scrollLeft)
      });
    };
    calculateButtonsVisibility();

    // При ресайзе пересчитываем возможность отображение кнопок
    window.addEventListener('resize', calculateButtonsVisibility);

    // При скролле вычисляем, какие кнопки показывать
    scrollableContainer.addEventListener('scroll', calculateButtonsVisibility);
    return () => {
      window.removeEventListener('resize', calculateButtonsVisibility);
      scrollableContainer.removeEventListener('scroll', calculateButtonsVisibility);
    };
  }, [scrollableContainerRef, deviceType]);
  const handleLeftChevronClick = useCallback(() => {
    const scrollableContainer = scrollableContainerRef.current;
    const tabsContainer = tabsRef.current;
    const tabs = Array.from(tabsContainer.children).slice().reverse();
    const scrollDistance = calculateScrollDistance({
      items: tabs,
      container: scrollableContainer,
      direction: 'left'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'left'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, tabsRef]);
  const handleRightChevronClick = useCallback(() => {
    const scrollableContainer = scrollableContainerRef.current;
    const tabsContainer = tabsRef.current;
    const tabs = Array.from(tabsContainer.children);
    const scrollDistance = calculateScrollDistance({
      items: tabs,
      container: scrollableContainer,
      direction: 'right'
    });
    scrollableContainer.scrollBy({
      left: getTotalScrollDistance(scrollDistance, 'right'),
      behavior: 'smooth'
    });
  }, [scrollableContainerRef, tabsRef]);
  return useMemo(() => _objectSpread(_objectSpread({}, buttonsVisibilityState), {}, {
    onLeftCarouselButtonClick: handleLeftChevronClick,
    onRightCarouselButtonClick: handleRightChevronClick
  }), [buttonsVisibilityState, handleLeftChevronClick, handleRightChevronClick]);
};